<template>
  <div class="phone-box" :class="{ 'phone-loading': loading }">
    <div class="new-popupbox box-loading" v-if="loading">
      <a-spin tip="正在读取教材内容，请稍后..." size="large" wrapperClassName="box-spin" />
    </div>
    <!-- 具体内容 -->
    <div class="phone-content-box">
      <a-empty class="empty-box" :image="simpleImage" v-if="intList.length == 0" />

      <phoneTopNav :hideBar="hideBar" :bar="bar"></phoneTopNav>
      <div class="phone-content">
        <div class="int-item" :id="int.PK_InductionGuid" :class="{ 'active': int.chapter_num == chapter_num }"
          v-for="int in intList">
          <div v-if="int.show">
            <div class="int-name">{{ int.InductionName }}</div>
            <div class="int-des" v-if="int.Description">{{ int.Description }}</div>
            <div class="paragraph" v-for="cint of int.children">
              <div class="cint-title">{{ cint.InductionName }}</div>
              <div class="list-box">
                <div class="list-item-box" :id="code.Guid" :class="{ lastSubmit: code.isLastSubmit }"
                  v-for="code of cint.data">
                  <div class="list-item" v-if="code.fold" @click="foldCode(code)">
                    <svg class="icon-svg code-icon">
                      <use :xlink:href="code.icon" />
                    </svg>
                    <div class="code-name">{{ code.typeName }}：{{ code.Title }}</div>
                    <div class="code-hanlder">
                      <svg class="icon-svg code-icon" v-if="code.isSubmited">
                        <use xlink:href="#icon-duihao" />
                      </svg>
                      <span class="code-noSubmited" v-if="!code.isSubmited">待完成</span>
                    </div>
                  </div>
                  <iframe class="iframe-content" allowfullscreen="true"
                    :class="{ textContent: code.ProjectCode == 'kb' || code.ProjectCode == 'kd' }" :ref="code.Guid"
                    :src="code.phoneIframe" scrolling="no" frameborder="0" name="ifd"
                    :style="{ height: code.height + 'px', width: code.width + 'px', }" @load="listenIframe(code)"
                    v-if="!code.fold"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <phoneBar :hideBar="hideBar" :bar="bar" :chapter_num="chapter_num" :intList="intList"
      @switchChapter="switchChapter($event, 'chapter')" @openCode="openCode($event)" @showBar="hideBar = $event">
    </phoneBar>

    <!-- iframe弹窗 -->
    <div class="new-popupbox phone-popupbox" :class="{ overturn: codeIframe.transform }" v-if="codeIframe">
      <div class="hanlder-box">
        <svg class="icon-svg popup-close" @click="codeIframe = null">
          <use xlink:href="#icon-guanbi" />
        </svg>
      </div>
      <iframe :ref="codeIframe.Guid" class="phone-iframe" :src="codeIframe.phoneIframe" scrolling="no" frameborder="0"
        allowfullscreen="true" name="ifd" @load="listenIframe(codeIframe)" v-if="codeIframe.transform"
        :style="{ height: codeIframe.height, width: codeIframe.width, transform: codeIframe.transform, top: codeIframe.top, left: codeIframe.left }"></iframe>
      <iframe :ref="codeIframe.Guid" class="phone-iframe" :src="codeIframe.phoneIframe" scrolling="no" frameborder="0"
        allowfullscreen="true" name="ifd" @load="listenIframe(codeIframe)" v-else></iframe>
    </div>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { PASSPORT_CLIENT_SERVER } from '@/config/url';

import phoneBar from '../phone-bar/phone-bar.vue';
import phoneTopNav from '../phone-top-nav/phone-top-nav.vue';


export default {
  name: 'phoneList',
  components: {
    LoadingOutlined, phoneBar, phoneTopNav
  },
  props: {
    intList: Array,
    stuList: Array,
  },
  data() {
    return {
      navFold: true,
      navMax: false,
      hideBar: false,
      chapter_num: null,
      loading: true,

      logo_icon: require("@/assets/images/phone/icon.png"),
      logo_text: require("@/assets/images/phone/icon-text.png"),
      fromType: "",
      platform_type: '',

      codeIframe: null,
      platform: null,
      userInfo: {},

      bar: {
        show_nav: false,
        show_npc: false,
        show_achievement: false
      },

      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    }
  },
  mounted() {
    let { platform, userInfo, fromType } = this.$store.state;

    this.theme_color = platform.pageConfig.theme_color;
    this.userInfo = userInfo;
    this.platform = platform;
    this.fromType = fromType;
    this.platform_type = platform.Type;

    if (fromType != "yuanxi") {
      this.logo_icon = platform.pageConfig.logo;
      this.logo_text = '';
    }

    let that = this;

    setTimeout(() => {
      $('.scroll-box').scroll(function () {
        if (!that.loading) {
          if ($(`.scroll-box`).scrollTop() == 0) that.hideBar = false;
          else if (($(`.scroll-box`).scrollTop() + $(`.scroll-box`).height()) == $(`.phone-box`).height()) that.hideBar = false;
          else that.hideBar = true;
        }
      })
    }, 3000)

    //加载所有iframe
    this.$nextTick(async () => { setTimeout(() => { this.setHeight() }, 500) })

    if (this.intList.length == 0) return this.loading = false;
    this.switchChapter(0, 'chapter');
  },
  methods: {
    //设置各互动高度
    setHeight() {
      this.intList.forEach(int => {
        int.children.forEach(citem => {
          citem.data.forEach(code => {
            if (code.ProjectCode == 'cs') code.height = ($(window).width() - 12) * (9 / 16);
            else if (code.ProjectCode == 'mi') code.height = ($(window).width() - 12) * (16 / 9);
            else if (code.ProjectCode == 'tr' || code.ProjectCode == 'intex') {
              code.transform = 'rotate(90deg)';
              code.width = `${$(window).height() - 20}px`;
              code.height = `${$(window).width() - 20}px`;
              code.top = `${($(window).height() - $(window).width() + 20) / 2}px`;
              code.left = `${-($(window).height() - $(window).width() - 20) / 2}px`;
            }
          })
        })
      })
    },
    //监听iframe传值
    listenIframe(code) {
      if (code.listener) return;
      let that = this;

      this.$nextTick(() => {
        let iframe = that.$refs[code.Guid];
        //判断是不是数组
        if (Array.isArray(iframe)) iframe = iframe[0];
        //发送值
        iframe.contentWindow.postMessage({
          command: 'postStudentId',
          data: {
            studentId: this.userInfo.PK_UserGuid,
          },
        }, '*')
        //接受值
        code.listener = window.addEventListener('message', function (e) {
          if (e.source != iframe.contentWindow) return;
          let data = e.data || { height: 600 };
          // console.log(code.Title + '：' + data)
          if (!data) return;

          let needChange = Math.abs(data.height - code.height) > 50 ? true : false;
          if (data.command == "updateHeight" && needChange) code.height = data.height;
          //修改微课尺寸
          if (data.command == "fullscreenToggle") {
            let vheight = ($(window).width() - 12) * (9 / 16);
            if (data.isFullscreen) vheight = ($(window).width() - 12) * (16 / 9);
            code.height = vheight;
            that.scrollTo(code.Guid);
          }
        })
      })
    },

    //切换章节
    switchChapter(num, type) {
      let chapter_num = this.chapter_num;
      if (num == chapter_num) return $('.scroll-box').animate({ scrollTop: 0 });

      this.loading = true;
      this.chapter_num = num;
      this.loadChapter(num);
      //互动初始高度
      this.intList.forEach((int, i) => {
        if (i == num) {
          if (!int.loadFinish) {
            int.children.forEach(citem => {
              citem.data.forEach(code => {
                if (this.platform_type == 'sz' && (code.ProjectCode == 'kb' || code.ProjectCode == 'kd')) code.fold = false;
              })
            })
            this.loadContent(int);
          }
          else {
            this.loading = false;
            if (type == 'chapter') $('.scroll-box').animate({ scrollTop: 0 })
          }
        }
      })
    },

    //加载内容
    loadContent(int) {
      //加载所有iframe
      this.$nextTick(async () => {
        setTimeout(() => {
          let scrollTop = $('.scroll-box').prop("scrollHeight");
          $('.scroll-box').animate({ scrollTop }, 1000);
        }, 500);
        setTimeout(() => {
          $('.scroll-box').animate({ scrollTop: 0 }, 1000);
        }, 1500);
        setTimeout(() => {
          this.loading = false;
          int.loadFinish = true;
        }, 3000);
      })
    },
    //加载前后章节
    loadChapter(num) {
      this.intList.forEach(int => { int.show = false })
      this.intList[num].show = true;
      if (num > 0) this.intList[num - 1].show = true
      if (num + 1 < this.intList.length) this.intList[num + 1].show = true;
    },
    //打开code
    openCode(code) {
      if (code.fold) this.foldCode(code);

      //是否加载章节并跳转
      let chapter_num = code.chapter_num;
      if (this.chapter_num != chapter_num) {
        this.switchChapter(chapter_num, 'code');

        this.intList.forEach((int, i) => {
          if (i == chapter_num) {
            if (int.loadFinish) this.scrollTo(code.Guid);
            else setTimeout(() => { this.scrollTo(code.Guid) }, 3000);
          }
        })
      }
      else this.scrollTo(code.Guid);
    },
    //展开code
    foldCode(code) {
      this.judgeOnline();
      switch (code.ProjectCode) {
        case 'hw':
        case 'co':
        case 'tr':
        case 'intex':
          this.codeIframe = code;
          break;
        default:
          code.fold = false;
      }
      // window.open(`${code.address}?token=${this.userInfo.token}`)
    },
    //判断用户是否在线
    async judgeOnline() {
      const ret = await this.$api.unifydata.verifyToken({ token: this.userInfo.token });
      if (ret.statusCode != 200) location.href = `${PASSPORT_CLIENT_SERVER}/yuanxi?redirectURI=${location.href}`;
    },
    //滚动到code
    scrollTo(id) {
      this.$nextTick(async () => {
        if ($(`#${id}`).offset()) {
          let scrollTop = $(`.scroll-box`).scrollTop() + $(`#${id}`).offset().top - 10;
          $('.scroll-box').animate({ scrollTop }, 300);
        }
      })
    },

    //组件销毁
    beforeUnmount() {
    }
  }
}


</script>

<style scoped lang="scss">
@import "./phone-list.scss";
</style>